import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./core/layout/pages/dashboard/dashboard.component').then(
        (m) => m.DashboardComponent
      ),
    title: 'Dashboard — AZ Symphony',
  },
  { path: '**', redirectTo: 'auth', pathMatch: 'full', title: 'AZ Symphony' },
];
